import { render, staticRenderFns } from "./FormResponseMessage.vue?vue&type=template&id=3fd64b60"
import script from "./FormResponseMessage.vue?vue&type=script&lang=js"
export * from "./FormResponseMessage.vue?vue&type=script&lang=js"
import style0 from "./FormResponseMessage.vue?vue&type=style&index=0&id=3fd64b60&prod&module=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports